import DatabaseModel from './DatabaseModel.js';

var Provincia = Object.create(DatabaseModel);

Provincia.model = 'provincia';
Provincia.modelFront = 'provincias';

export default Provincia;